import * as types from '@/store/mutation-types';

const state = {
  trial: {
    daysLeft: 0,
    endDate: null,
  },
  status: null,
  userAttributes: [],
};

const getters = {
  trial() {
    return state.trial;
  },
  status() {
    return state.status;
  },
  userAttributes() {
    return state.userAttributes;
  },
};

const mutations = {
  [types.SET_TRIAL_DAYS_LEFT](state, p) {
    state.trial.daysLeft = p.daysLeft;
    state.trial.endDate = p.endDate;
  },
  [types.SET_CURRENT_USER_PROFILE_PIC](state, p) {
    p.currentUser.pic = p.pic;
  },
  [types.SET_ACCOUNT_STATUS](state, p) {
    state.status = p.status;
  },
  [types.SET_USER_ATTRIBUTES](state, p) {
    state.userAttributes = p;
  },
};

const actions = {
  setTrialDaysLeft: ({ commit }, p) => {
    commit(types.SET_TRIAL_DAYS_LEFT, p);
  },
  setAccountStatus: ({ commit }, p) => {
    commit(types.SET_ACCOUNT_STATUS, p);
  },
  setUserProfilePic: ({ commit, rootState }, payload) => {
    payload.currentUser = rootState.Users.currentUser;
    commit(types.SET_CURRENT_USER_PROFILE_PIC, payload);
  },
  setUserAttributes: ({ commit }, p) => {
    commit(types.SET_USER_ATTRIBUTES, p);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/admin/account/vuex.js